<script setup lang="ts">
import { AudioLines, Code2, Languages, ListChecks, Mic, Music2, UserSquare, Video } from 'lucide-vue-next'
import { computed } from 'vue'
import { useI18n } from '../../../../base/src/composables/useI18n'
import en from '../../locales/en'
import zh from '../../locales/zh'

const { t } = useI18n({ zh, en })

const features = computed(() => [
  { icon: AudioLines, title: t('muse.intro.feature.tts'), desc: t('muse.intro.feature.ttsDesc') },
  { icon: Mic, title: t('muse.intro.feature.clone'), desc: t('muse.intro.feature.cloneDesc') },
  { icon: Music2, title: t('muse.intro.feature.template'), desc: t('muse.intro.feature.templateDesc') },
  { icon: UserSquare, title: t('muse.intro.feature.avatar'), desc: t('muse.intro.feature.avatarDesc') },
  { icon: Video, title: t('muse.intro.feature.video'), desc: t('muse.intro.feature.videoDesc') },
  { icon: Languages, title: t('muse.intro.feature.lang'), desc: t('muse.intro.feature.langDesc') },
  { icon: Code2, title: t('muse.intro.feature.api'), desc: t('muse.intro.feature.apiDesc') },
  { icon: ListChecks, title: t('muse.intro.feature.task'), desc: t('muse.intro.feature.taskDesc') },
])
</script>

<template>
  <section id="features" class="relative scroll-mt-20 py-12 sm:py-20">
    <div class="mx-auto max-w-6xl px-5 sm:px-8">
      <div class="mx-auto max-w-2xl text-center">
        <div class="text-2xl font-black tracking-tight sm:text-3xl">{{ t('muse.intro.feature.title') }}</div>
        <div class="mt-3 text-sm text-gray-500 sm:text-base dark:text-gray-400">
          {{ t('muse.intro.feature.subtitle') }}
        </div>
      </div>

      <div class="mt-10 grid grid-cols-2 gap-x-5 gap-y-8 sm:mt-12 sm:grid-cols-4 sm:gap-x-6 sm:gap-y-10">
        <div
          v-for="(feature, index) in features"
          :key="feature.title"
          v-reveal
          class="group"
          :style="{ transitionDelay: `${(index % 4) * 70}ms` }"
        >
          <div
            class="flex h-11 w-11 items-center justify-center rounded-2xl border border-primary-100/80 bg-primary-50 text-primary transition-transform duration-200 group-hover:-translate-y-0.5 motion-reduce:transition-none dark:border-primary-800/60 dark:bg-primary-900/30"
          >
            <component :is="feature.icon" class="h-5 w-5" aria-hidden="true" />
          </div>
          <div class="mt-3 text-sm font-semibold text-gray-900 dark:text-gray-100">{{ feature.title }}</div>
          <div class="mt-1 text-xs leading-relaxed text-gray-500 sm:text-sm dark:text-gray-400">
            {{ feature.desc }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
